import HubAboutNhsTherapyModule from './HubAboutNhsTherapyModule'

export default HubAboutNhsTherapyModule
